export const createPaySession = async (packageId: string, email?: string) =>
  await fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/payments/create-pay-session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ packageId, email }),
  });

export const createPayInvoiceSession = async (invoiceId: string, abortController: AbortController) =>
  await fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/payments/create-invoice-pay-session`, {
    method: "POST",
    signal: abortController.signal,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ invoiceId }),
  });

export const updatePaySession = async (paymentId: string, packageId: string) =>
  await fetch(`${process.env.NEXT_PUBLIC_SUBSCRIPTION_HOST}/api/payments/update-pay-session`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ paymentId, packageId }),
  });

export const checkIfUserIsAlreadySubsribed = async (userEmail: string) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/00000001/StripeSubscriptionServerSide/IsUserAlreadySubscribedToSubscription?userEmail=${userEmail}`
  );
